namespace('compass.group');

compass.require('compass.group.HotelManageWidget');

compass.group.HotelManageListWidget = compass.defineWidget(function HotelManageListWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = jQuery.dom;

	var _settings = options;

	var SEARCH_MESSAGES = {
		NO_RESULTS: 'There are no results for '
	};

	me.hotels = [];
	me.update = function(updateData) {
		var updateMethods = {
			removeHotel: function(hotel) {
				_removeHotel(hotel, updateData.hotel_id);
			}
		};

		_.each(me.hotels, function(hotel) {
			if(updateData.hotel_id === hotel.hotel_id) {
				_.each(updateData.data, function(data, key) {
					if(updateMethods[key]) {
						updateMethods[key](hotel);
					}
				});
				hotel.widget.update(updateData);
			}
		});
	};

	var _removeHotel = function(hotel_widget, hotel_id) {
		hotel_widget.widget.remove();
		me.hotels = _.reject(me.hotels, function(hotel) {
			return hotel_id === hotel.hotel_id;
		});
	};

	var _updateSearchPaneMessage = function(message){
		me.getWidgetElem().empty();
		me.getWidgetElem().append(d.div({className: 'searchResults'}, SEARCH_MESSAGES.NO_RESULTS, d.span({className: 'searchTerm'}, '"' + message + '"')));
	};

	var _setupHotels = function(hotelContainer, hotelsArray) {

		if(!hotelsArray.length && _settings.searchText.length){
			_updateSearchPaneMessage(_settings.searchText);
		}

		_.each(hotelsArray, function(hotel) {
			
			var _hotelManageWidget = new compass.group.HotelManageWidget(hotelContainer, {
				WUID: hotel.hotelData.hotelBase.name + 'ManageWidget',
				searchMode: _settings.searchText.length ? true : false,
				hotelData: hotel.hotelData,
				blockData: hotel.blockData,
				meetingInfo: _settings.meetingInfo,
				requestsInfo: _settings.requestsInfo,
				cancelInfo: _settings.cancelInfo,
				groupInfo: _settings.groupInfo,
				countriesAndStates: _settings.countriesAndStates,
				cancelReasons : _settings.cancelReasons,
				hideDistance : _settings.hideDistance,
				canSendConfo : _settings.canSendConfo
			});
			me.hotels.push({hotel_id: hotel.hotelData.hotelBase.hotel_id, widget: _hotelManageWidget});
		});
	};

	this.render = function(widgetElem) {
		_setupHotels(widgetElem, _settings.hotels);
	};

	me.bind('HotelManageWidget.removeHotel', function(event, eventData) {
		_.each(me.hotels, function(hotel) {
			if(eventData.hotel_id === hotel.hotel_id) {
				_removeHotel(hotel, eventData.hotel_id);
			}
		});

		if(me.hotels.length === 0){
			if (_settings.searchText === '') {
				me.trigger('HotelManageListWidget.lastHotelRemoved');
			} else {
				_updateSearchPaneMessage(_settings.searchText);
			}
		}
	});

}, {
	WUID: 'DEFAULT',
	widgetName: 'HotelManageListWidget',
	searchText: '',
	hotels: [],
	meetingInfo: {},
	requestsInfo: {},
	cancelInfo: {},
	groupInfo: {},
	countriesAndStates: {}
});
